import firebase from 'firebase/app'
import 'firebase/auth'

const state = {
	authUser: null,
	user: {
		firstName: "",
		lastName: "",
		email: "",
		bio: "",
		username: "",
		photoURL: "",
		photoFile: null,
		linkedGoogle: false,
		bookmarkedStories: [],
		following: [],
		followers: [],
		likes: [],
		shares: [],
		feedback: [],
		groups: [],
		notifications: [],
		recentActivity: {
			reads: [],
			others: []
		},
		stateInitialized: false
	},
	userView: {
		following: [],
		followers: [],
		likes: [],
		shares: [],
		bio: ''
	}
}

const getters = {
	getAuthUser: state => {
		return state.authUser
	},
	bookmarkCount: state => {
		return state.user.bookmarkedStories.length
	},
	feedbackCount: state => {
		return state.user.feedback.length
	},
	getUserPhotoURL: state => {
		return state.user.photoURL
	},
	getUserStats: state => {
		let stats = {
			following: state.user.following,
			followers: state.user.followers,
			likes: state.user.likes,
			shares: state.user.shares
		}

		return stats
	},
	getUserInfo: state => {
		let info = {
			firstName: state.user.firstName,
			lastName: state.user.lastName,
			email: state.user.email,
			bio: state.user.bio,
			username: state.user.username,
			photoURL: state.user.photoURL,
		}

		return info
	},
	getUserViewStats: state => {
		return state.userView
	},
	getUserShares: state => {
		return state.user.shares
	},
	getUserLikes: state => {
		return state.user.likes
	},
	getUserBookmarks: state => {
		return state.user.bookmarkedStories
	},
	getNotifications: state => {
		return state.user.notifications
	},
	getGroups: state => {
		return state.user.groups
	},
	getRecentReadsActivity: state => {
		return state.user.recentActivity.reads
	},
	getRecentOthersActivity: state => {
		return state.user.recentActivity.others
	}
}

const mutations = {
	setAuthUser: (state, payload) => {
		state.authUser = payload
	},
	setUserInfo: (state, payload) => {
		state.user.firstName = payload.firstName ? payload.firstName : state.user.firstName
		state.user.lastName = payload.lastName ? payload.lastName : state.user.lastName
		state.user.bio = payload.bio ? payload.bio : state.user.bio
		state.user.email = payload.email ? payload.email : state.user.email
		state.user.username = payload.username ? payload.username : state.user.username
		state.user.photoURL = payload.photoURL ? payload.photoURL : state.user.photoURL
	},
	setUserStats: (state, payload) => {
		state.user.followers = payload.followers
		state.user.following = payload.following
		state.user.likes = payload.likes
		state.user.shares = payload.shares
		state.user.groups = payload.groups.reverse()
		state.user.bookmarkedStories = payload.bookmarkedStories
	},
	setFeedback: (state, payload) => {
		state.user.feedback = payload
	},
	updateUserView: (state, payload) => {
		state.userView = payload
	},
	addAuthUserFollowing: (state, payload) => {
		state.userView.following.push(payload)
		state.user.following.push(payload)
	},
	removeAuthUserFollowing: (state, payload) => {
		let userToRemove = state.userView.following.indexOf(payload)
		state.userView.following.splice(userToRemove, 1)
		state.user.following.splice(userToRemove, 1)
	},
	addUserFollowers: (state, payload) => {
		state.userView.followers.push(payload)
		state.user.following.push(payload)
	},
	removeUserFollowers: (state, payload) => {
		let userToRemove = state.userView.followers.indexOf(payload)
		state.userView.followers.splice(userToRemove, 1)
		state.user.following.splice(userToRemove, 1)
	},
	addGroup: (state, payload) => {
		state.user.groups.unshift(payload)
	},
	removeNotification: (state, payload) => {
		let notifToRemove = state.user.notifications.findIndex(item => item.id === payload)
		state.user.notifications.splice(notifToRemove, 1)
	},
	addNotifications: (state, payload) => {
		state.user.notifications = payload
	},
	deleteGroup: (state, payload) => {
		let groupToRemove = state.user.groups.indexOf(payload)
		state.user.groups.splice(groupToRemove, 1)
	},
	updateRecentReadsActivity: (state, payload) => {
		const recentActivityURLS = state.user.recentActivity.reads.map(activity => activity.url)

		if (recentActivityURLS.includes(payload.url)) {
			const storyToMove = state.user.recentActivity.reads.findIndex(story => story.url === payload.url)
			state.user.recentActivity.reads.splice(storyToMove, 1)
			state.user.recentActivity.reads = [payload, ...state.user.recentActivity.reads]
			return
		}

		state.user.recentActivity.reads = [payload, ...state.user.recentActivity.reads]
	},
	bookmarkStory: (state, payload) => {
		state.user.bookmarkedStories = [payload, ...state.user.bookmarkedStories]
	},
	unbookmarkStory: (state, payload) => {
		const storyToRemove = state.user.bookmarkedStories.findIndex(story => story.url === payload.url)
		state.user.bookmarkedStories.splice(storyToRemove, 1);
	},
	likeStory: (state, payload) => {
		state.user.likes = [payload, ...state.user.likes]
	},
	unlikeStory: (state, payload) => {
		const storyToRemove = state.user.likes.findIndex(story => story.url === payload.url)
		state.user.likes.splice(storyToRemove, 1);
	},
	shareStory: (state, payload) => {
		state.user.shares = [payload, ...state.user.shares]
	},
	unshareStory: (state, payload) => {
		const storyToRemove = state.user.shares.findIndex(story => story.url === payload.url)
		state.user.shares.splice(storyToRemove, 1);
	},
	signOut: (state) => {
		state.authUser = null
		state.user.firstName = ""
		state.user.lastName = ""
		state.user.email = ""
		state.user.photoURL = ""
		state.user.linkedGoogle = false
		state.user.bookmarkedStories = []
		state.user.username = ""
		state.user.following = []
		state.user.followers = []
		state.user.likes = []
		state.user.shares = []
		state.user.groups = []
		state.user.feedback = []
		state.user.notifications = []
		state.user.stateInitialized = false
		state.user.groups = []
	}
}

const actions = {
	setAuthUser: ({
		commit
	}, payload) => {
		commit('setAuthUser', payload)
	},
	setUserInfo: ({
		commit
	}, payload) => {
		commit('setUserInfo', payload)
	},
	signOut: ({
		commit
	}) => {
		firebase.auth().signOut()
		setTimeout(() => {
			commit('signOut')
		}, 1000)
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js